module.exports = __webpack_public_path__ + "img/orange_unlock.0c48658c.gif";